// extracted by mini-css-extract-plugin
export default {"addressSection":"jU-z","disabled":"kU-z","sectionButtons":"lU-z","logo":"mU-z"};